import styled from "styled-components";
import { setFont } from "@similarweb/styles";
import { colorsPalettes } from "@similarweb/styles";

export const Disable = styled.label`
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    cursor: inherit;
    width: fit-content;
    ${setFont({ $size: 14, $color: colorsPalettes.carbon[100] })};
`;
